<template>
  <div class="app flex-row mt-3 animated fadeIn">
    <b-container>
      <b-row class="justify-content-center">
        <b-col xl="5" lg="7" md="9">
          <!-- <b-img class="d-block mx-auto mb-3" src="/img/logo-full.png" fluid :alt="$t('shared.AppLogo')" /> -->
          <div v-if="sent">
            <b-alert show variant="success" class="my-4"> Reset password email sent to {{ Email }} </b-alert>
            <div class="d-flex">
              <font-awesome-icon icon="thumbs-up" class="display-4 mx-2 text-moremuted" />
              <h5 class="p-3">
                <div class="mb-1 text-white">Please check your Email inbox</div>
                <small class="text-white-50">We sent you instructions to reset your password.</small>
              </h5>
            </div>
          </div>
          <div v-else>
            <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
              <ul class="m-0 px-1">
                <li v-for="err in errors.all()" :key="err">{{ err }}</li>
              </ul>
            </b-alert>
            <b-card class="mb-3 p-4">
              <h4 class="h4 font-weight-bold text-center">
                Forgot Your Password?
              </h4>
              <p class="text-muted">
                Enter your account Email address to reset your password
              </p>

              <div v-if="progressing" class="text-center">
                <font-awesome-icon spin icon="circle-notch" class="text-moremuted display-2" />
              </div>

              <b-form v-else @submit.prevent="submit">
                <b-input-group class="mb-3">
                  <b-input-group-prepend is-text>
                    <font-awesome-icon icon="user" />
                  </b-input-group-prepend>
                  <b-form-input
                    dir="ltr"
                    placeholder="Email Address"
                    name="Email Address"
                    v-validate="'required|email'"
                    v-model="Email"
                  >
                  </b-form-input>
                </b-input-group>
                <b-btn @click="submit" :disabled="progressing" variant="warning" class="btn-block mb-3">Recover Account</b-btn>
                <b-btn to="/" variant="link" class="btn-block">Go back to Log in window</b-btn>
              </b-form>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'forgot-password',
  data() {
    return {
      progressing: false,
      error: null,
      sent: false,
      Email: null
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.progressing = true
          const model = {
            Email: this.Email
          }
          this.$api.account
            .ForgotPassword(model, true)
            .then(() => {
              this.progressing = false
              this.sent = true
            })
            .catch(err => {
              this.progressing = false
              if (err.response.data) {
                this.$showError(err.response.data.message)
              } else {
                this.$showError('error was occured')
              }
            })
        }
      })
    }
  }
}
</script>
